const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
const persistSubscription = (subscriptionData) => {
    const token = document.querySelector('meta[name=csrf-token]').getAttribute('content');
    fetch('/push', {
        method: 'POST',
        body: JSON.stringify(subscriptionData),
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-CSRF-Token': token }
    }).catch(err => {});
};
const subscribe = (reg) => {
    let { subscribeOptions } = App;
    reg.pushManager.subscribe({
        ...subscribeOptions,
        applicationServerKey: urlBase64ToUint8Array(subscribeOptions.applicationServerKey)
    }).then(persistSubscription)
      .catch(err => {})
};
const checkPermission = async (reg) => {
    let permission = await Notification.requestPermission();
    if(permission) {
        subscribe(reg);
    }
};

if('serviceWorker' in navigator) {
    const needed =
        (
            location.pathname.startsWith('/junior') ||
            location.pathname.startsWith('/teenage') ||
            location.pathname.startsWith('/kids')
        ) &&
        (typeof App !== "undefined" && App.user && App.user.member_type === 1);
    if(needed) {
        const { serviceWorker } = navigator;
        serviceWorker
            .register('/sw.js')
            .then(checkPermission);
    }
}

